import MUIAccordionActions, { AccordionActionsProps } from "@mui/material/AccordionActions";
import React, { FC } from "react";

export const AccordionActions: FC<AccordionActionsProps> = (props) => <MUIAccordionActions {...(props as any)} />;
